import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import "@/i18n";
import ErrorBoundary from "@/components/ErrorBoundary";
import { installGlobalErrorReporters } from "@/lib/errorReporter";

// Feed client-side crashes into the Founder System Health view.
installGlobalErrorReporters();

// Capture the optional ?winter_month=N seasonal preview before the router can
// strip the query on an auth redirect (harmless; Today reads it to preview Winter Mode).
try {
  const _wm = new URLSearchParams(window.location.search).get("winter_month");
  if (_wm) sessionStorage.setItem("hg_winter_preview", _wm);
} catch { /* ignore */ }

// One-time cleanup: an earlier build registered a service worker that serves a
// stale cached bundle to returning visitors. Unregister any existing service
// workers and clear their caches so everyone gets the latest build. This build
// does NOT register a new service worker.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
}
if (typeof caches !== "undefined" && caches.keys) {
  caches
    .keys()
    .then((keys) => keys.forEach((k) => caches.delete(k)))
    .catch(() => {});
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
